import useNavCollapse from "../../hooks/useNavCollapose.hook";
import ChevronDoubleLeftIcon from "../../icons/chevronDoubleLeft.icon";

export default function NavCollaposeBtn() {
  const [collapse, setNavCollapse] = useNavCollapse();

  if (collapse) return null;

  return (
    <button className="cursor-pointer" onClick={() => setNavCollapse(true)}>
      <ChevronDoubleLeftIcon />
    </button>
  );
}
